import { Globe } from "lucide-react";
import { changeLanguage, getCurrentLanguage } from "@/packages/utils";
import { useState } from "react";

export function AuthLanguageSwitcher() {
  const [lang, setLang] = useState(getCurrentLanguage);

  const toggle = () => {
    const next = lang === "de" ? "en" : "de";
    changeLanguage(next);
    setLang(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      className="flex items-center gap-1.5 text-muted hover:text-primary transition-colors text-sm"
      title={lang === "de" ? "Switch to English" : "Zu Deutsch wechseln"}
    >
      <Globe size={16} />
      <span className="text-xs font-medium uppercase">{lang}</span>
    </button>
  );
}
